export const application = (state) => state?.entities?.application;
export const applicationList = (state) =>
  application(state) ? Object.values(application(state)) : [];
